import { CIcon } from '~/icons/types'

export const ciShipping: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.718 11.259 19.8 7.214a1 1 0 0 0-.718-.3h-2.368l.153-1.827a1 1 0 0 0-1-1.083H4.2a1 1 0 0 0-1 .917L3.034 7H1.956a1 1 0 0 0 0 2h.911l-.061.73H1a1 1 0 0 0 0 2h1.64l-.4 4.833a1 1 0 0 0 1 1.083H4.3a3.122 3.122 0 0 0 6.044 0H14.9a.98.98 0 0 0 .325-.062 3.124 3.124 0 0 0 6.06.119h1.392a1 1 0 0 0 1-.932L24 12.023a1 1 0 0 0-.282-.764Zm-5.062-2.35 1.825 1.884H16.39l.157-1.883h2.109ZM8.122 17.644a1.14 1.14 0 0 1-1.858-1.238 1.135 1.135 0 0 1 1.052-.702 1.142 1.142 0 0 1 1.14 1.136 1.132 1.132 0 0 1-.333.803h-.001Zm5.856-2h-3.757A3.144 3.144 0 0 0 5.1 14.622c-.293.292-.526.64-.684 1.023h-.097l.327-3.916H7.4a1 1 0 1 0 0-2H4.813l.061-.73H7.9a1 1 0 0 0 0-2H5.041l.083-1h9.66l-.806 9.644Zm5.1 2.02a1.143 1.143 0 0 1-1.613 0 1.132 1.132 0 0 1 0-1.6 1.138 1.138 0 1 1 1.612 1.607l.001-.006Zm2.107-1.963a3.141 3.141 0 0 0-.694-1.057 3.215 3.215 0 0 0-4.422-.014l.154-1.84h5.718l-.2 2.91h-.556Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'shipping',
  type: 'regular'
}
